import { Component, OnInit, Inject } from '@angular/core';
import { Option } from 'app/core/contracts/models/option';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { Address } from 'src/app/core/contracts/models/address.model';
import { UbigeoService } from 'src/app/core/services/api/ubigeo.service';
import { TypeAddressService } from 'src/app/core/services/api/type-address.service';


@Component({
    selector: 'app-types-of-addresses-form',
    templateUrl: './types-of-addresses-form.component.html',
    styleUrls: ['./types-of-addresses-form.component.scss']
})
export class TypesOfAddressesFormComponent implements OnInit {

    addresses: Option[] = [];
    address: Address = {
        idTipoDireccion: null,
        tipo_direccion: null,
        direccion: null,
        country: null,
        filterCountry: null,
        region: null,
        filterRegion: null,
        zipCode: null,
        departamento: null,
        filterDepartamento: null,
        provincia: null,
        filterProvincia: null,
        distrito: null,
        filterDistrito: null
    };

    title = 'Agregar dirección';
    buttonSubmit = true;

    countries = [];
    regions = [];

    department = [];
    provincias = [];
    distritos = [];

    distSelect: any;
    countD: number = 1;

    isPeru: boolean = false;
    loadingRegions: boolean = false;
    loadingCountries: boolean = false;
    isRegionEnabled: boolean = false;
    isDepartamentoEnabled: boolean = false;
    isProvinciaEnabled: boolean = false;
    isDistritoEnabled: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<TypesOfAddressesFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { data: Address, district: boolean },
        private ubigeoService: UbigeoService,
        private typeAddressService: TypeAddressService,
    ) {
        if (data.data) {
            this.title = 'Editar dirección';
            this.address.tipo_direccion = data.data.tipo_direccion;
            this.address.idTipoDireccion = data.data.tipo_direccion.id;
            this.address.direccion = data.data.direccion;
            this.address.zipCode = data.data.zipCode;
            this.address.country = data.data.country.id;
            this.address.region = data.data.region.id
        }
    }

    ngOnInit(): void {

        this.getCountries();

        if (this.address.country) {
            this.onCountryChange(this.address.country);
        }

        this.typeAddressService.getAll().subscribe((response: any) => {
            this.addresses = response.data;
        });


        if (this.data.district) {
            /*   this.departmentos = this.places.getDepartamentos();
              if (this.data.data && this.data.data.ubigeo) {
                  this.distSelect = this.places.findPlace(this.data.data.ubigeo);
                  this.districtForm.get('departamento').setValue(this.distSelect.department_id);
              } */
        }

        // Si estamos editando y es Perú, cargar los datos del ubigeo
        if (this.data?.data && this.data.data.country?.id === 176 && this.data.data.ubigeo) {
            this.loadUbigeoData(this.data.data.ubigeo);
        }
    }

    getCountries() {
        this.loadingCountries = true
        this.ubigeoService.getCountries().subscribe(
            (data) => {
                this.countries = data.countries.map((country: any) => ({
                    name_es: country.name_es,
                    id: country.id
                }));
                this.loadingCountries = false
                // Si se está editando y ya hay un país seleccionado, cargar las regiones
                if (this.address.country) {
                    this.onCountryChange(this.address.country);
                }
            },
            (error) => {
                console.error('Error al cargar contries', error);
                this.loadingCountries = true
            }
        );
    }

    onCountryChange(countryId) {
        // Resetear todos los campos dependientes
        this.resetDependentFields();
        this.isRegionEnabled = true
        this.isDepartamentoEnabled = false;
        this.isProvinciaEnabled = false;
        this.isDistritoEnabled = false;
        this.isPeru = countryId === 176;

        if (this.isPeru) {
            this.getDepartments();
        } else if (countryId || countryId === 0) {
            this.getRegions(countryId);
        }
    }

    getRegions(countryId: number) {
        this.loadingRegions = true;
        this.ubigeoService.getRegions(countryId).subscribe(
            (data) => {
                this.regions = data.regions.map((region: any) => ({
                    name: region.name,
                    id: region.id
                }));;

                if (this.data?.data?.region?.id) {
                    this.address.region = this.data.data.region.id;
                }
                this.loadingRegions = false;
            },
            (error) => {
                console.error('Error al cargar regiones', error);
                this.loadingRegions = false;
            }
        );
    }

    getDepartments() {
        this.ubigeoService.getDepartment().subscribe(
            (data) => {
                this.department = data.map((department) => ({
                    name: department.nombre,
                    id: department.id
                }));
                this.isDepartamentoEnabled = true;


            },
            (error) => {
                console.error('Error al cargar departamentos', error);
            }
        );
    }

    onDepartmentChange(departmentId: number) {
        // Guardamos el departamento seleccionado
        this.address.departamento = departmentId;
        this.address.provincia = null;
        this.address.distrito = null;
        this.provincias = [];
        this.distritos = [];

        //Desabilitar temporalmente
        this.isProvinciaEnabled = false;
        this.isDistritoEnabled = false;

        if (departmentId) {
            this.getProvinces(departmentId);
        }
    }

    getProvinces(departmentId: number) {
        this.ubigeoService.getProvinces(departmentId).subscribe(
            (data) => {
                this.provincias = data.map((provincia) => ({
                    name: provincia.nombre,
                    id: provincia.id
                }));

                this.isProvinciaEnabled = true;
            },
            (error) => {
                console.error('Error al cargar provincias', error);
            }
        );
    }

    onProvinceChange(provinceId: number) {
        this.address.provincia = provinceId;
        this.address.distrito = null;
        this.distritos = [];
        this.isDistritoEnabled = false;

        if (provinceId) {
            this.getDistricts(provinceId);
        }
    }

    getDistricts(provinceId: number) {
        this.ubigeoService.getDistrict(provinceId).subscribe(
            (data) => {
                this.distritos = data.map((distrito) => ({
                    name: distrito.nombre,
                    id: distrito.id
                }));

                this.isDistritoEnabled = true;
            },
            (error) => {
                console.error('Error al cargar distritos', error);
            }
        );
    }

    resetDependentFields() {
        this.address.region = null;
        this.address.departamento = null;
        this.address.provincia = null;
        this.address.distrito = null;
        this.regions = [];
        this.department = [];
        this.provincias = [];
        this.distritos = [];
    }

    //cargar datos de ubigeo
    loadUbigeoData(ubigeo: string) {
        const departamentoCode = ubigeo.substring(0, 2) + '0000';
        const provinciaCode = ubigeo.substring(0, 4) + '00';

        // Cargar departamentos
        this.ubigeoService.getDepartment().subscribe(departments => {
            this.department = departments.map(d => ({
                name: d.nombre,
                id: d.id
            }));

            // Seleccionar el departamento
            const selectedDept = this.department.find(d => d.id === departamentoCode);
            if (selectedDept) {
                this.address.departamento = selectedDept.id;
                this.isDepartamentoEnabled = true;

                // Cargar provincias del departamento
                this.ubigeoService.getProvinces(selectedDept.id).subscribe(provinces => {
                    this.provincias = provinces.map(p => ({
                        name: p.nombre,
                        id: p.id
                    }));

                    // Seleccionar la provincia
                    const selectedProv = this.provincias.find(p => p.id === provinciaCode);
                    if (selectedProv) {
                        this.address.provincia = selectedProv.id;
                        this.isProvinciaEnabled = true;

                        // Cargar distritos de la provincia
                        this.ubigeoService.getDistrict(selectedProv.id).subscribe(districts => {
                            this.distritos = districts.map(d => ({
                                name: d.nombre,
                                id: d.id
                            }));

                            // Seleccionar el distrito
                            const selectedDist = this.distritos.find(d =>
                                d.id === ubigeo || d.name === this.data.data.distrito
                            );
                            if (selectedDist) {
                                this.address.distrito = selectedDist.id;
                                this.isDistritoEnabled = true;
                            }
                        });
                    }
                });
            }
        });
    }

    onSubmit(form: NgForm) {
        this.buttonSubmit = false;
        if (form.invalid) {
            this.buttonSubmit = true;
            return;
        }

        this.address.tipo_direccion = this.addresses.find(a => a.id === this.address.idTipoDireccion);
        this.address.ubigeo = this.address.distrito;

        const selectedCountry = this.countries.find(c => c.id === this.address.country);
        this.address.country = selectedCountry ? { id: selectedCountry.id, name_es: selectedCountry.name_es } : { id: null, name_es: '---' };// nombre del país

        if (this.isPeru) {
            const selectDepartment = this.department.find(d => d.id === this.address.departamento);
            this.address.region = selectDepartment ? { id: selectDepartment.id, name: selectDepartment.name } : { id: null, name: '---' };
        } else {
            const selectRegion = this.regions.find(r => r.id === this.address.region);
            this.address.region = selectRegion ? { id: selectRegion.id, name: selectRegion.name } : { id: null, name: '---' };
        }

        //console.log("Datos enviando", this.address);
        this.dialogRef.close({ ...this.address });
    }

    cancel() {
        this.dialogRef.close(this.data.data);
    }


}




